const stepsProject = [
  {
    selector: ".relatorio-title",
    content:
      "Essa é a área de relatório, em que você pode extrair dados de projetos ou colaboradores através de gráficos ou de modo analítico.",
  },
  {
    selector: ".projectHeader",
    content:
      "Essa é a aba de Projetos, aqui você pode navegar entre as opções a direita.",
  },
  {
    selector: ".selectProject",
    content: "Para extrair o relatório, selecione um projeto.",
  },
  {
    selector: ".datesProject",
    content: "Selecione o período de tempo.",
  },
  {
    selector: ".epicsProject",
    content: "Selecione o épico (opcional).",
  },
  {
    selector: ".buttonApplyFiltersProject",
    content: "Aplique os filtros clicando no botão.",
  },
];

const stepsColaborador = [
  {
    selector: ".colaboradorHeader",
    content: "Essa é a aba de Colaborador, vamos extrair o relatório.",
  },
  {
    selector: ".selectColaborador",
    content: "Para extrair o relatório, selecione um colaborador.",
  },
  {
    selector: ".datesColaborador",
    content: "Selecione o período de tempo.",
  },
  {
    selector: ".selectProjectsColaborador",
    content: "Selecione o(s) projeto(s) (opcional).",
  },
  {
    selector: ".selectEpicsColaborador",
    content: "Selecione o(s) épico(s) (opcional).",
  },
  {
    selector: ".buttonApplyFiltersColaborador",
    content: "Aplique os filtros clicando no botão.",
  },
];

const stepsPivottable = [
  {
    selector: ".aspectosAnaliticosHeader",
    content:
      "Essa é a aba de aspectos analíticos em que você consegue analisar os dados pela pivottable.",
  },
  {
    selector: ".selectProjectsPivottable",
    content: "Selecione o(s) projeto(s).",
  },
  {
    selector: ".datesPivottable",
    content: "Selecione o período de tempo.",
  },
  {
    selector: ".buttonApplyFiltersPivottable",
    content: "Aplique os filtros clicando no botão.",
  },
];

const stepsPlanejamento = [
  {
    selector: ".planejamento-title",
    content:
      "Essa é a área de planejamento em que é possível visualizar através do Gantt os épicos, sua duração e participantes referentes ao projeto selecionado.",
  },
  {
    selector: ".selectProjectPlanejamento",
    content: "Selecione o projeto.",
  },
  {
    selector: ".selectEpicoPlanejamento",
    content: "Selecione o épico (opcional).",
  },
  {
    selector: ".selectStatusEpicoPlanejamento",
    content: "Selecione o status do épico (opcional).",
  },

  {
    selector: ".pesquisaPorColaborador",
    content: "Pesquise por colaborador digitando aqui.",
  },
  {
    selector: ".buttonAplicarFiltrosPlanejamento",
    content: "Aplique os filtros clicando no botão.",
  },
];

const stepsLixeira = [
  {
    selector: ".title-lixeira",
    content:
      "Nesta área você visualiza as atas enviadas para lixeira. Marque nos checkbox a(s) que você deseja excluir permanentemente ou restaurar para área de listagem.",
  },
  {
    selector: ".ordenar-atas-lixeira",
    content:
      "Aqui você visualiza algumas opções de ordenação das atas listadas nessa área.",
  },
  {
    selector: ".input-pesquisa-lixeira",
    content: "Neste campo você pode filtrar as atas pelo conteúdo digitado.",
  },
  {
    selector: ".delete-ata-button",
    content:
      "Clicando aqui você será redirecionado para o modal de confirmação da deleção da(s) ata(s) selecionada(s).",
  },
  {
    selector: ".restaurar-ata-button",
    content: "Clicando aqui você pode restaurar a(s) ata(s) selecionada(s).",
  },
];

const stepsDocumentosAta = [
  {
    selector: ".tituloDocumentosAta",
    content:
      "Aqui você está na listagem de atas. Abaixo você encontra alguns filtros.",
  },
  {
    selector: ".projetosFiltro",
    content: "Neste campo é possível filtrar as atas pelo projeto.",
  },
  {
    selector: ".clientesFiltro",
    content: "Neste campo é possível filtrar as atas pelo cliente.",
  },
  {
    selector: ".autorFiltro",
    content: "Neste campo é possível filtrar as atas pelo autor.",
  },
  {
    selector: ".buttonNovoDocumento",
    content: "Clique aqui para criar uma nova ata.",
  },
  {
    selector: ".buttonLixeira",
    content: "Clique aqui para ir a lixeira.",
  },
  {
    selector: ".buttonOrdenarPor",
    content: "Clique para visualizar as opções de ordenação.",
  },
  {
    selector: ".campoPesquisar",
    content: "Digite aqui para pesquisar.",
  },
];
const stepsNovaAta = [
  {
    selector: ".tituloNovaAta",
    content: "Você está na área de criação de ata.",
  },
  {
    selector: ".voltar",
    content: "Selecione para voltar para a listagem de atas.",
  },

  {
    selector: ".camposObrigatorios",
    content: "Preencha os campos obrigatórios para criação da ata.",
  },
  {
    selector: ".data",
    content: "Selecione a data.",
  },
  {
    selector: ".horarioInicial",
    content: "Selecione o horário inicial da ata.",
  },
  {
    selector: ".horarioFinal",
    content: "Selecione o horário final da ata.",
  },
  {
    selector: ".duracao",
    content: "Visualize a duração da ata.",
  },
  {
    selector: ".clientes",
    content: "Selecione o cliente.",
  },
  {
    selector: ".projetos",
    content: "Selecione o projeto.",
  },
  {
    selector: ".participantesCliente",
    content: "Digite o nome do Cliente.",
  },
  {
    selector: ".participantesColaborador",
    content: "Selecione o colaborador.",
  },
  {
    selector: ".pontosAbordadosItem",
    content: "Digite o item do ponto abordado.",
  },
  {
    selector: ".pontosAbordadosDescricao",
    content: "Digite a descrição do ponto abordado.",
  },
  {
    selector: ".decisoesTomadasDecisao",
    content: "Digite a decisão",
  },
  {
    selector: ".decisoesTomadasReferencia",
    content: "Digite o item referente a decisão tomada.",
  },
  {
    selector: ".proximosPassosAtividade",
    content: "Selecione a atividade",
  },
  {
    selector: ".proximosPassosResponsavel",
    content: "Selecione o responsável pela atividade.",
  },
  {
    selector: ".proximosPassosDescricao",
    content: "Digite a descrição dos próximos passos.",
  },
  {
    selector: ".proximosPassosAtividadesDoTaiga",
    content: "Digite o link da atividade do taiga.",
  },
  {
    selector: ".proximosPassosPrazo",
    content: "Selecione o prazo dessa atividade.",
  },
  {
    selector: ".buttonCancelar",
    content: "Clique aqui para cancelar.",
  },
  {
    selector: ".buttonCriarEditar",
    content: "Clique aqui para criar a ata.",
  },
  {
    selector: ".buttonEdicao",
    content: "Clique aqui para criar/salvar a ata.",
  },
  {
    selector: ".buttonDowload",
    content: "Clique aqui para criar/salvar a ata.",
  },
];

const stepsEdicaoAta = [
  {
    selector: ".tituloEditarAta",
    content:
      "Você está na área de edição da ata e este é o título da ata selecionada na tela anterior. Ele é composto pelo nome do projeto, cliente e a data de criação da ata.",
  },

  {
    selector: ".buttonDesabilitarEdicao",
    content: "Selecione o botão para habilitar/desabilitar o modo de edição.",
  },
  {
    selector: ".buttonDownload",
    content: "Selecione o botão para fazer o download da ata.",
  },
  {
    selector: ".buttonExcluir",
    content: "Selecione o botão para excluir a ata.",
  },
  {
    selector: ".voltar",
    content: "Selecione para voltar para a listagem de atas.",
  },

  {
    selector: ".camposObrigatorios",
    content:
      "Essa é a seção dos campos obrigatórios. Neste modo não é possível alterar essas informações, apenas visualizar.",
  },

  {
    selector: ".step-participantes",
    content: "Visualize/Edite os Participantes da ata.",
  },

  {
    selector: ".pontosAbordados",
    content: "Visualize/Edite os pontos abordados.",
  },

  {
    selector: ".decisoesTomadas",
    content: "Visualize/Edite as Decisões Tomadas.",
  },

  {
    selector: ".proximosPassos",
    content: "Visualize/Edite os Próximos Passos.",
  },
];
const stepsPerfil = [
  {
    selector: ".novaAtaTitulo",
    content: "Bem vindo(a)! Você está na página inicial do Apolo!",
  },
  {
    selector: ".ultimasAtualizacoesTitle",
    content: "Aqui você visualiza as últimas atas criadas.",
  },
  {
    selector: ".atalhosPerfil",
    content: "Nessa seção você encontra alguns atalhos.",
  },
  {
    selector: ".novaAta",
    content: "Selecione para criar uma nova ata.",
  },
  {
    selector: ".abrirDocumento",
    content: "Selecione para ir para tela de listagem de atas.",
  },
];

const stepsPerfilGestor = [
  {
    selector: ".novaAtaTitulo",
    content: "Bem vindo(a)! Você está na página inicial do Apolo!",
  },
  {
    selector: ".ultimasAtualizacoesTitle",
    content: "Aqui você visualiza as últimas atas criadas.",
  },
  {
    selector: ".atalhosPerfil",
    content: "Nessa seção você encontra alguns atalhos.",
  },
  {
    selector: ".novaAta",
    content: "Selecione para criar uma nova ata.",
  },
  {
    selector: ".abrirDocumento",
    content: "Selecione para ir para tela de listagem de atas.",
  },
  {
    selector: ".abrirPainelGestao",
    content: "Selecione para ir ao painel de gestão.",
  },
];

const stepsConfiguracoes = [
  {
    selector: ".configuracoesTitle",
    content:
      "Nessa área você pode visualizar na tabela abaixo dados dos usuários, clientes e projetos existentes.",
  },
  {
    selector: ".headerTabela",
    content:
      "Clicando nessas opções você pode navegar entre as abas de Usuários, Projetos e Clientes.",
  },
  {
    selector: ".barraDePesquisa",
    content: "Digite aqui para pesquisar na aba atual.",
  },
];
const stepsAtaPdf = [
  {
    selector: ".cancelar-pdf",
    content: "Clique aqui para cancelar e voltar a página anterior.",
  },
  {
    selector: ".download-pdf",
    content: "Clica aqui para baixar a ata em formato pdf.",
  },
];

export {
  stepsProject,
  stepsColaborador,
  stepsPivottable,
  stepsPlanejamento,
  stepsDocumentosAta,
  stepsNovaAta,
  stepsPerfil,
  stepsEdicaoAta,
  stepsConfiguracoes,
  stepsLixeira,
  stepsAtaPdf,
  stepsPerfilGestor,
};
